export default __webpack_public_path__ + "static/carlos_planchart-3aa1661150e2dea46c5e933210895163.jpg";